import { appAxios } from "@/lib/config/apiInterceptor";

export const fetchDesigns = async () => {
    try {
      // Fetch fresh data from the API
      const response = await appAxios.get(`/design/get`);
      const data = response.data;
  
      // Format the data
      const formattedData: DesignItem[] = data.designs.map((design: any) => ({
        id: design.id,
        name: design.name,
        category: design.category,
        image: JSON.parse(design.image).split(",").map((img: string) => img.trim()),
        createdAt: design.createdAt,
      }));
  
  
      return formattedData;
    } catch (error) {
      console.error("Error fetching designs: ", error);
      return null;
    }
  };